import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=1f777a52&"
import script from "./Question.vue?vue&type=script&lang=ts&"
export * from "./Question.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports